export const GET_SUBCATEGORIES_REQUEST = 'GET_SUBCATEGORIES_REQUEST';
export const GET_SUBCATEGORIES_SUCCESS = 'GET_SUBCATEGORIES_SUCCESS';
export const GET_SUBCATEGORIES_FAILURE = 'GET_SUBCATEGORIES_FAILURE';

export const getSubcategoriesRequest = (data) => ({
  type: GET_SUBCATEGORIES_REQUEST,
  payload: data,
});

export const getSubcategoriesSuccess = (data) => ({
  type: GET_SUBCATEGORIES_SUCCESS,
  payload: data,
});

export const getSubcategoriesFailure = (error) => ({
  type: GET_SUBCATEGORIES_FAILURE,
  payload: error,
});